/**
 * Debounced search filter component.
 * Manages its own local state to prevent parent re-renders on every keystroke.
 * Only propagates the value after a 300ms debounce.
 */
import React, { useState, useEffect } from 'react';
import { TextFilter } from '@amzn/awsui-components-core';

interface DebouncedSearchFilterProps {
  onFilterChange: (text: string) => void;
  placeholder?: string;
}

export const DebouncedSearchFilter: React.FC<DebouncedSearchFilterProps> = React.memo(({ onFilterChange, placeholder = 'Filter resources' }) => {
  const [localValue, setLocalValue] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      onFilterChange(localValue);
    }, 300);
    return () => clearTimeout(timer);
  }, [localValue, onFilterChange]);

  return (
    <TextFilter
      filteringText={localValue}
      filteringPlaceholder={placeholder}
      filteringAriaLabel="Filter resources"
      onChange={({ detail }) => setLocalValue(detail.filteringText)}
    />
  );
});
